import moment from 'moment';
/**
 * @description Утилита для обнуления секунд и миллисекунд (таймзона нужна, чтобы отправлялось московское время, а не серверное)
 * */
export const payloadTimeFormatter = (time: string): string => {
    const moscow_offset = 3 * 60;

    return moment(time).second(0).millisecond(0).utcOffset(moscow_offset).format();
};
